import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Values from './components/Values';
import Team from './components/Team';
import Portfolio from './components/Portfolio';
import News from './components/News';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Header from './components/Header';

export default function Home() {
  const [activeSection, setActiveSection] = useState('home');

  return (
    <div className="min-h-screen bg-white">
      <Header activeSection={activeSection} setActiveSection={setActiveSection} />
      <Hero />
      <About />
      <Values />
      <Team />
      <Portfolio />
      <News />
      <Contact />
      <Footer />
    </div>
  );
}
